import {useState, useEffect, useMemo} from 'react'
import { t } from 'i18next'
import { FormGroup, Label, Input } from 'reactstrap'

import { isNull } from '../../../izUtils'
import DisplayHistory from '../../../helpers/DisplayHistory'
import useComponentVisible from '../../../helpers/hooks/useComponentVisible'

const MultiSelect = ({data, onChange, showErrors, lsFilterName, component, history, showDictionary}) => {
    const { name, display, errors, title, values, disabled, mandatory} = data
    const isFilter = !isNull(lsFilterName)

    const [value, setValue] = useState([])
    const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false, '', 'multi-select-dropdown-'+name);

    useEffect(() => {
        setValue(isNull(data.value) ? [] : [...data.value])
    }, [data.value])

    const handleChange = (optionId) => {
        let newValue;
        if (value.indexOf(optionId) === -1) {
            newValue = [...value, optionId];
            setValue(newValue);
        } else {
            newValue = value.filter(el => el !== optionId);
            setValue(newValue);
        }

        // Save filter data to LS, so it can be used if user clicks "Confirm" button
        if (isFilter) {
            let lsFilter = JSON.parse(localStorage.getItem(lsFilterName))
            if (!isNull(lsFilter)) {
                for (const filterName in lsFilter) {
                    if (filterName === name) {
                        lsFilter[filterName].value = newValue;
                        localStorage.setItem(lsFilterName, JSON.stringify(lsFilter))

                        const callBEAfterChange = ['client', 'facility', 'security_system', 'manufacturer', 'system', 'central'] // BE needs to be called after changing one of these filters, because they are related to other filters
                        if (callBEAfterChange.indexOf(name) !== -1) {
                            onChange(newValue, name)
                        }
                    }
                }
            }
        } else {
            onChange(newValue, name)
        }
    };

    const displayedValues = useMemo(() => {
        let displayedName = (name === 'technician' ? t('defaultTechnician') : t('defaultSelect'))

        if (!isNull(value) && value.length > 0) {
            displayedName = '';

            values.forEach((option, i) => {
                if (value.indexOf(option.id) !== -1) {
                    displayedName += (displayedName !== '') ? ', ' + option.title : option.title;
                }
            });
        }

        return displayedName;
    }, [value, values]) // eslint-disable-line react-hooks/exhaustive-deps

    if (display) {
        return (
            <FormGroup>
                <div className="d-flex align-items-center">
                    <Label>{title + (mandatory ? " *" : "")}</Label>
                </div>
                <div
                    ref={ref}
                    style={{ width: '100%', position: 'relative' }}
                >
                    <div
                        id={"multi-select-"+name}
                        className='form-control digits form-select'
                        name={name}
                        style={ disabled ? { zIndex: '200', background: '#ededed', cursor: 'not-allowed' } : { zIndex: '200', cursor: 'pointer' } }
                    >
                        {displayedValues}
                    </div>
                    {/* DROPDOWN */}
                    {!disabled &&
                        <div id={'multi-select-dropdown-'+name} className="multi-select-dropdown" style={{ display: isComponentVisible ? 'block' : 'none' }}>
                            <ul className="multi-select-options form-check">
                                {values.map((option, i) => (
                                    <li
                                        key={option.title + '-' + i}
                                        className="form-checkbox-group"
                                    >
                                        <Label
                                            htmlFor={option.id + (isNull(component) ? '' : '-' + component.id)}
                                        >
                                            <Input
                                                className="custom-control-input"
                                                id={option.id + (isNull(component) ? '' : '-' + component.id)}
                                                type={"checkbox"}
                                                onChange={(e) => {
                                                    handleChange(option.id);
                                                }}
                                                checked={value.indexOf(option.id) !== -1}
                                                disabled={disabled}
                                            />
                                            <div className="checkmark"></div>
                                            <div className="custom-control-label">{option.title}</div>
                                        </Label>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    }
                </div>
                {!isNull(showErrors) && showErrors && !isNull(errors) && errors.length !== 0 && <div style={{ color: "red", marginBottom: "10px" }}>{errors.map((error, index) => <div key={"error-"+index}>{error}</div>)}</div>}
                {(!isNull(history) && history.length > 0) && <DisplayHistory history={history} data={data} />}
            </FormGroup>
        )
    } else {
        return null
    }
}

export default MultiSelect